<template>
  <div id="cell-renderer-history" class="flex items-center">
    <div>
      <div class="label-created">{{ created }}</div>
      <div class="label-history">
        {{ params.value.name }}さんが{{ params.value.action }}しました。
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "CellRendererStatus",
  data() {
    return {
      created: "",
    };
  },
  created() {
    this.created = moment(this.params.value.created_at).format(
      "YYYY/MM/DD HH:mm"
    );
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
@import "@/assets/scss/aisea/vessel-noon-report.scss";

#cell-renderer-history {
  height: 100%;
  .label-history {
    line-height: normal;
    font-size: 12px;
  }
  .label-created {
    line-height: normal;
  }
}
</style>
